<template>
  <div class="logoutModalWrap" v-if="visivle === true">
    <div class="logoutModal">
      <p class="lead">
        <strong> 正常にログアウト<br class="hiddenPc" />しました</strong>
      </p>

      <button type="button" class="close" @click="$emit('close')">
        <img src="@/assets/images/icon/close-main.svg" alt="" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'LogoutModal',

  props: {
    visivle: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.logoutModalWrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 999;

  @include mixins.media() {
    background-color: rgba(255, 255, 255, 0.9);
  }
}

.logoutModal {
  padding: 50px 40px;
  border: 1px solid var.$color-main;
  border-radius: 15px;
  position: relative;
  background-color: #fff;

  @include mixins.media() {
    width: 712px;
    padding: 40px 90px;
  }
}

.lead {
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: var.$color-main;

  &::before {
    content: '';
    display: block;
    width: 54px;
    height: 54px;
    margin: 0 auto 10px;
    background: url('~@/assets/images/icon/check.svg') no-repeat;
    background-size: 100% 100%;

    @include mixins.media() {
      margin-bottom: 20px;
    }
  }

  > strong {
    font-weight: inherit;
  }
}

.close {
  position: absolute;
  top: -35px;
  right: 0;

  > img {
    width: 20px;
    height: 20px;
  }
}

::v-deep(.button) {
  max-width: none;
}
</style>
